import { SharedState } from '@trello/shared-state';
import { isWorkspaceNavigationEnabled } from '@trello/workspaces';

interface WorkspaceNavigationState {
  expanded: boolean;
}

export const workspaceNavigationState = new SharedState<
  WorkspaceNavigationState
>({
  expanded: isWorkspaceNavigationEnabled(),
});
